<template>
  <div class="admin ">
    <alert
      v-model="notify.show"
      :errorType="notify.type"
      :message="notify.message"
    />
    <new-tenant-modal
      @notify="handleNotify($event)"
      v-model="showTenantModal"
    />
    <new-lesson-modal
      @notify="handleNotify($event)"
      v-model="showLessonModal"
    />
    <new-admin-asset
      @notify="handleNotify($event)"
      v-model="showAdminAssetModal"
    />
    <edit-admin-modal
      @notify="handleNotify($event)"
      v-model="showEditAdminModal"
    />
    <update-password
      @notify="handleNotify($event)"
      v-model="showPasswordModal"
    />
    <update-profile
      @notify="handleNotify($event)"
      v-model="showUpdateProfileModal"
    />
    <new-admin-modal @notify="handleNotify($event)" v-model="showAdminModal" />
    <div class="flex flex-row min-h-screen w-full">
      <nav-bar v-show="!showNav" class="fixed" />
      <div class="w-full ">
        <div class=" top-0 z-10">
          <top-bar @toggle-nav="showNav = true" />
        </div>
        <div style="background-color: #f5f3f3 !important" class="min-h-screen">
          <div class="main mx-4 py-4 flex-grow">
            <router-view
              @notify="handleNotify($event)"
              @create-tenant="showTenantModal = true"
              @create-admin="showAdminModal = true"
              @create-lesson="showLessonModal = true"
              @create-admin-asset="showAdminAssetModal = true"
              @edit-admin-modal="showEditAdminModal = true"
              @update-password-modal="showPasswordModal = true"
              @update-profile-modal="showUpdateProfileModal = true"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="showNav"
      class="lg:hidden mobile-side fixed w-full min-h-screen  top-0"
    >
      <div
        class="bg-red-900 h-full z-10 w-full"
        style="background: rgba(18, 32, 103, 0.5);"
        id="qqq"
      >
        <div @click.prevent="showNav = false" class="mobile-menu h-full w-3/5">
          <div class="mx-2 py-2">
            <div
              @click.prevent="showNav = false"
              class="cursor-pointer text-white mb-12"
            >
              <i class="fas fa-times fa-3x"></i>
            </div>
            <div class="text-white intro-foo">
              <div id="mobile_adminstration" class="mx-6 my-8">
                <router-link
                  v-if="getUser.role === 'Super Admin'"
                  :class="{ active: activePath == '/admin' }"
                  class="nav-item mb-4 flex flex-row"
                  to="/admin"
                >
                  <i class="fas fa-user-lock mt-1 mr-3"></i
                  ><span>Administration</span>
                </router-link>
              </div>
              <div id="mobile_tenant" class="mx-6 my-8">
                <router-link
                  v-if="getUser.role === 'Super Admin'"
                  :class="{ active: activePath == '/admin/tenant-management' }"
                  :to="{ name: 'manage-tenant' }"
                  class="flex flex-row nav-item mb-4 "
                >
                  <i class="fas fa-users mt-1 mr-3"></i><span>Tenants</span>
                </router-link>
              </div>
              <div id="mobile_permissions" class="mx-6 my-8">
                <router-link
                  v-if="getUser.role === 'Super Admin'"
                  :class="{ active: activePath == '/admin/roles' }"
                  :to="{ name: 'admin-roles' }"
                  class="flex flex-row nav-item mb-4"
                >
                  <i class="fas fa-user-shield mt-1 mr-3"></i
                  ><span>Permissions</span>
                </router-link>
              </div>
              <div id="mobile_resources" class="mx-6 my-8">
                <router-link
                  :class="{
                    active: activePath.match('/admin/resources'),
                  }"
                  to="/admin/resources"
                  class=" nav-item "
                  ><i class="fas fa-folder mt-1 mr-3"></i>
                  <span>Resources</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import * as introJs from "intro.js";
//import "intro.js/minified/introjs.min.css";
export default {
  data() {
    return {
      showAdminModal: false,
      showTenantModal: false,
      showLessonModal: false,
      showAdminAssetModal: false,
      showEditAdminModal: false,
      showPasswordModal: false,
      showUpdateProfileModal: false,
      alert: false,
      showNav: false,
      notify: {
        type: null,
        show: false,
        message: "",
      },
    };
  },
  components: {
    TopBar: () => import("@/components/admin/topbar"),
    NavBar: () => import("@/components/admin/Nav"),
    NewAdminModal: () => import("@/components/admin/modal"),
    NewLessonModal: () => import("@/components/admin/new_lesson"),
    NewAdminAsset: () => import("@/components/admin/new_asset"),
    NewTenantModal: () => import("@/views/admin/create-tenant"),
    Alert: () => import("@/components/admin/alert"),
    EditAdminModal: () => import("@/components/admin/edit-admin"),
    UpdatePassword: () => import("@/components/admin/password"),
    UpdateProfile: () => import("@/components/admin/update-profile"),
  },
  computed: {
    ...mapGetters(["getUser", "getToken"]),
    activePath() {
      return this.$route.path;
    },
  },
  methods: {
    handleNotify(payload) {
      this.notify.show = true;
      this.notify.type = payload.type;
      this.notify.message = payload.message;
    },
  },
  mounted() {
    this.$Bus.$on("notify", (data) => {
      this.notify.show = true;
      this.notify.type = data.type;
      this.notify.message = data.message;
    });
    this.$Bus.$on("show-admin-sidenav", () => {
      this.showNav = true;
    });
    if (!this.getUser || !this.getToken) {
      this.$router.push("/");
    }
  },
};
</script>
<style lang="scss">
.admin {
  .main {
    // styles for the main body of the admin section
    .heading {
      background-color: color(lms-admin);
    }
    .page {
      font-size: 32px;
      font-weight: 600;
    }
  }
  .topbar {
    background-color: #fff;
    color: #2e3a6e;

    .right {
      div {
        margin-right: 25px;
        color: color(lms-admin);
      }
    }
  }
  .sidebar {
    background-color: color(lms-admin);

    a {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-top: 1rem;
      padding-bottom: 1rem;
      padding-left: 1.5rem;
      cursor: pointer;
      color: #fff;

      &.active {
        background-color: #fff !important;
        color: black;
      }
    }
  }
  .tenant-sidebar {
    background-color: color(lms-tenant);

    a {
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding-top: 1rem;
      padding-bottom: 1rem;
      cursor: pointer;
      color: #fff;

      &.active {
        background-color: #fff !important;
        color: black;
      }
    }
  }
  .mobile-menu {
    background-color: color(lms-admin);
    width: 230px;
  }

  .mobile-side {
    height: 200px;
    overflow-y: auto;
  }
}
</style>
